module.exports = __webpack_public_path__ + "static/media/apartment17.3457a287.jpg";